const src = require("/app/src/assets/images/svg/email.svg?as-resource");
const img = new String(src);
img.src = src;
img.width = 37;
img.height = 33;
img.toString = function() { return src; };
module.exports = img;